import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimelineNavHelperService {
  public direction = new BehaviorSubject<string>(null);
  public isNavigating: boolean = false; // For ignoring scroll triggers.

  constructor() {}

  public YearForward() {
    this.direction.next('forward');
  }
  public YearBack() {
    this.direction.next('back');
  }
}
